export const STATUS = ['ALL', 'DRAFT', 'APPROVED'];
export const BRANDS = [
  'luxuryescapes',
  'cudotravel',
  'scoopontravel',
  'dealstravel',
  'kogantravel',
  'leagenthub',
  'leagenthub_cvfr',
];
